import React from "react";
import { Link } from "react-router-dom";

const FooterOne = () => {
  return (
    <footer className="footer py-120 bg-neutral-900 text-gray-300 mt-13">
      <div className="container container-lg">
        <div className="row gy-5">
          {/* ===== BRAND / INFO ===== */}
          <div className="col-12 col-md-6 col-lg-3">
            <Link to="/" className="d-inline-block mb-20">
              <img
                src="/assets/images/logo/logo4.png"
                alt="MordenBazaar"
                style={{ height: "40px" }}
              />
            </Link>

            <p className="text-gray-400 mb-20">
              MordenBazaar — One Stop Marketplace
            </p>
            {/* 
            <div className="mb-12 d-flex align-items-center gap-12">
              <i className="ph-fill ph-map-pin text-main-600" />
              <span>India</span>
            </div> */}

            <div className="mb-12 d-flex align-items-center gap-12">
              {/* <i className="ph-fill ph-phone text-main-600" /> */}
              <a
                href="tel:+919993553538"
                className="mb-12 d-flex align-items-center gap-12 text-decoration-none"
              >
                <i className="ph-fill ph-phone text-main-600" />
                <span>+91 9993553538</span>
              </a>
            </div>

            <div className="d-flex align-items-center gap-12">
              <i className="ph-fill ph-envelope text-main-600" />
              <a href="https://mail.google.com/mail/u/0/">
                support@mordenbazaar.com
              </a>
            </div>
          </div>

          {/* ===== QUICK LINKS ===== */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="mb-20 text-white">Quick Links</h6>
            <ul className="footer-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/account">Account</Link>
              </li>
              <li>
                <Link to="/marketplace-declaration">Declaration</Link>
              </li>
            </ul>
          </div>

          {/* ===== CUSTOMER SERVICE ===== */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="mb-20 text-white">Customer Service</h6>
            <ul className="footer-menu">
              <li>
                <Link to="/shipping-policy">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-use">Terms of Use</Link>
              </li>
              <li>
                <Link to="/order-policy">Order Policy</Link>
              </li>
              <li>
                <Link to="/payment-policy">Payment Policy</Link>
              </li>
            </ul>
          </div>

          {/* ===== ACCOUNT ===== */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="mb-20 text-white">My Account</h6>
            <ul className="footer-menu">
              <li>
                <Link to="/account">Dashboard</Link>
              </li>
              <li>
                <Link to="/wishlist">Wishlist</Link>
              </li>
              <li>
                <Link to="/cart-one">Cart</Link>
              </li>
            </ul>
          </div>

          {/* ===== VENDOR + APP ===== */}
          <div className="col-6 col-md-3 col-lg-3">
            <h6 className="mb-20 text-white">For Vendors</h6>
            <ul className="footer-menu mb-20">
              <li>
                <Link to="/become-seller">Become a Vendor</Link>
              </li>
              <li>
                <Link to="/vendor-policy">Vendor Policy</Link>
              </li>
              <li>
                <a
                  href="https://vendor.mordenbazaar.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Vendor Login
                </a>
              </li>
            </ul>

            <div className="d-flex flex-wrap gap-12">
              <a
                href="https://linktr.ee/mordenbazaar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/thumbs/appstores.png"
                  alt="App Store"
                  className="img-fluid"
                  style={{ height: "36px", maxWidth: "100%" }}
                />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.mordenbazaar.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/thumbs/googleplays.png"
                  alt="Google Play"
                  className="img-fluid"
                  style={{ height: "36px", maxWidth: "100%" }}
                />
              </a>
            </div>
          </div>
        </div>

        {/* ===== BOTTOM BAR ===== */}
        <div className="border-top mt-60 pt-20 d-flex flex-column flex-md-row justify-content-between align-items-center gap-16">
          <p className="mb-0 text-gray-500">
            {/* © Copyright {new Date().getFullYear()} MordenBazaar. All rights
            reserved. */}
            © Copyright 2026 FZ Signature Tools Private Limited. All rights
            reserved.
          </p>

          <div className="d-flex gap-12">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <i className="ph-fill ph-facebook-logo" />
            </a>
            <a
              href="https://instagram.com/mordenbazaar_"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ph-fill ph-instagram-logo" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <i className="ph-fill ph-twitter-logo" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <i className="ph-fill ph-linkedin-logo" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterOne;
